import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import type { Locale } from '@ulucu/shared';

export const LOCALE_OPTIONS: Array<{ value: Locale; label: string; nativeLabel: string }> = [
	{ value: 'zh-CN', label: '简中', nativeLabel: '简体中文' },
	{ value: 'zh-TW', label: '繁中', nativeLabel: '繁體中文' },
	{ value: 'en-US', label: 'EN', nativeLabel: 'English' },
	{ value: 'es-ES', label: 'ES', nativeLabel: 'Español' },
	{ value: 'es-MX', label: 'ES-MX', nativeLabel: 'Español México' },
	{ value: 'ar-SA', label: 'AR', nativeLabel: 'العربية' },
];

export function normalizeLocaleValue(value?: string): Locale {
	if (value?.startsWith('zh-TW') || value?.startsWith('zh-HK')) return 'zh-TW';
	if (value?.startsWith('zh')) return 'zh-CN';
	if (value?.startsWith('es-MX')) return 'es-MX';
	if (value?.startsWith('es')) return 'es-ES';
	if (value?.startsWith('ar')) return 'ar-SA';
	if (value?.startsWith('en')) return 'en-US';
	return 'zh-CN';
}

export default function LocaleSwitcher() {
	const { i18n } = useTranslation();
	const value = normalizeLocaleValue(i18n.resolvedLanguage || i18n.language);
	return (
		<Select
			value={value}
			onChange={(v) => {
				try { localStorage.setItem('i18nextLng', v); } catch { /* ignore */ }
				void i18n.changeLanguage(v);
			}}
			options={LOCALE_OPTIONS}
			getPopupContainer={(triggerNode) => triggerNode.parentElement ?? document.body}
			style={{ width: 130 }}
		/>
	);
}
